import * as FileSaver from 'file-saver';

export const exportToCSV = async (
  apiData: Record<string, unknown>[],
  fileName: string,
  fileExtension = '.csv'
) => {
  const XLSX = await import('xlsx');
  const fileType = 'text/csv;charset=utf-8';
  const ws = XLSX.utils.json_to_sheet(apiData);
  const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
  let excelBuffer = XLSX.write(wb, { bookType: 'csv', type: 'string', FS: ';' });
  excelBuffer = '\uFEFF' + excelBuffer;
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};

export const exportToPDF = async (fileName: string, template: any) => {
  const { generate } = await import('@pdfme/generator');
  const pdf = await generate(template);
  const blob = new Blob([pdf.buffer], { type: 'application/pdf' });
  FileSaver.saveAs(blob, `${fileName}.pdf`);
};
